export default __webpack_public_path__ + "static/media/oneclick.2f31b217.png";